import React, { useEffect, useState } from 'react';
import "react-data-table-component-extensions/dist/index.css";
import '../../modalright.css'
import '../../popup.css'
import axios from 'axios';
import { useLocation } from 'react-router-dom';
export default function PlanDispatch() {
    // Dummy data for drivers and locations
    const API_URL = process.env.REACT_APP_API_URL;
    const [activeTab, setActiveTab] = useState('allocated');
    const [activeSubTab, setActiveSubTab] = useState('timeline');
    const location = useLocation();
    const [routes, setRoutes] = useState([]);
    const [routesUnassigned, setRoutesUnassigned] = useState([]);
    const [planId, setPlanId] = useState('');
  
    const [selectedDrivers, setSelectedDrivers] = useState({});
    const [driversall, setdriversall] = useState([])
    

    const getUserList = async () => {
        const API_PATH = `${API_URL}shypvdriverapp/driver/getAllDrivers`;
        
        try {
            const res = await axios.get(API_PATH);
            console.log(res.data);
            setdriversall(res.data.data);
          
        } catch (err) {
            console.log(err);
        }
    };

    console.log('drivers',driversall);
    console.log('state is: ',location.state)
    useEffect(() => {
      // Retrieve the passed data from location.state
      if (location.state) {console.log('state 2 is: ',location.state)
      const allRoutes = location.state.routes;
      setPlanId(location.state.planId);

      // Separate assigned and unassigned routes
      const assignedRoutes = allRoutes.filter(route => route.order_status === 'PLANNED');
      const unassignedRoutes = allRoutes.filter(route => route.order_status === 'UNASSIGNED');

      // Update state for assigned and unassigned routes
      setRoutes(assignedRoutes);  // This will store the assigned routes
      setRoutesUnassigned(unassignedRoutes);


      
      }
      getUserList()
    }, [location]);
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setActiveSubTab('timeline'); // Reset to timeline when main tab changes
    };

    const handleSubTabClick = (subTab) => {
        setActiveSubTab(subTab);
    };

    const dispatchButton={
        background: '#fff',
        border: '2px solid green',
        borderRadius: '5px',
        color: 'green'
    }
    const [dispatchedOrders, setDispatchedOrders] = useState([]);


    const prepareDispatchData = () => {
        const dispatches = location.state.routes
          .filter(route => selectedRoutes[route.order_id]) // Only include selected routes
          .map(route => ({
            driver_id: parseInt(selectedDrivers[route.order_id]) || route.driver_id,
            order_id: route.order_id
          }));
    
        return {
          plan_id: planId,
          dispatches: dispatches
        };
      };
    

    const dispatchPlan = async () => {

         const requestData = prepareDispatchData();
console.log('requestData ',requestData)
        // Only proceed if there are selected dispatches
        if (requestData.dispatches.length === 0) {
          alert("No routes selected for dispatch.");
          return;
        }

        const API_Dispatch =  `${API_URL}shypvdriverapp/configure/dispatchPlan`;
        
      
    
        try {
            const response = await axios.post(API_Dispatch, requestData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
    
            if (response.data.success) {
                alert('plan dispatched')
                console.log('Dispatch Plan Successfully Created:', response.data);

                const dispatchedOrderIds = requestData.dispatches.map(dispatch => dispatch.order_id);
setDispatchedOrders(prevState => [...prevState, ...dispatchedOrderIds]);

// const updatedRoutes = routes.filter(route => !dispatchedOrderIds.includes(route.order_id));
        
// // Step 4: Update the routes state with the remaining routes
// setRoutes(updatedRoutes);
            } else {
              alert('Error dispatching plan:')
                console.error('Error dispatching plan', response.data.errors);
            }
        } catch (error) {
          alert('Error occurred while dispatching plan')
            console.error('Error occurred while dispatching plan:', error);
        }
    };

  // State to track individual checkbox selections
  const [selectedRoutes, setSelectedRoutes] = useState({});

  // State to track the "Select All" checkbox status
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRouteMap, setSelectedRouteMap] = useState(null);
  // Handle the "Select All" checkbox click
  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;

    // If "Select All" is checked, set all individual checkboxes to true
    const updatedRoutes = routes.reduce((acc, route) => {
      acc[route.order_id] = isChecked;  // Set every route as checked or unchecked
      return acc;
    }, {});

    setSelectedRoutes(updatedRoutes);
    setSelectAll(isChecked);
  };

  // Handle individual checkbox click
  const handleRouteChange = (order_id, e) => {
    console.log(selectedRoutes)
    
    const isChecked = e.target.checked;

    // Update the selectedRoutes state with the new value for this route
    setSelectedRoutes((prevSelectedRoutes) => ({
      ...prevSelectedRoutes,
      [order_id]: isChecked,
    }));
  };

  useEffect(() => {
    // Check if all routes are selected
    const allSelected = routes.every((route) => selectedRoutes[route.order_id]);
    setSelectAll(allSelected);
  }, [selectedRoutes, routes]);

  // Check if all individual checkboxes are selected to update the "Select All" checkbox
  const handleRouteClick = (route) => {
    setSelectedRouteMap(route); // Set the selected route with latitude and longitude
  };
    

  const handleDriverChange = (orderId, driverId) => {
    // Update the selected driver for a specific route
    setSelectedDrivers(prev => ({
      ...prev,
      [orderId]: driverId
    }));
  };

  useEffect(() => {
    const initialDriverSelection = {};
    routes.forEach(route => {
      if (route.driver_id) {
        initialDriverSelection[route.order_id] = route.driver_id;
      }
    });
    setSelectedDrivers(initialDriverSelection);
  }, [routes]);

  const countRoutesByStatus = (routes) => {console.log('routes is:',routes)
    return routes.reduce((acc, route) => {
      if (route.order_status === 'PLANNED') {
        acc.assigned += 1;
      } else if (route.order_status === 'UNASSIGNED') {
        acc.unassigned += 1;
      }
      return acc;
    }, { assigned: 0, unassigned: 0 });
  };
  
  const { assigned, unassigned } = countRoutesByStatus(location.state.routes);

  console.log('xxxx',selectedDrivers)
    return (
        <div className="wrapper-holder">
        <div className="main-panel ps-container">
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header card-header-primary">
                                    {/* <h4 className="card-title">Plan</h4> */}
                                </div>
                                <div className="card-body">
      <div className="tabs">
        {/* <div className="tab" onClick={() => handleTabClick('tour')}>Tour (30)</div> */}
        <div className="tab" onClick={() => handleTabClick('allocated')}>Allocated ({assigned})</div>
        <div className="tab" onClick={() => handleTabClick('unallocated')}>Unallocated ({unassigned})</div>
      </div>

    

      {/* Main Tab Content */}
      <div className="tab-content">
      <div className="dispatchbtn" style={{ width: '24%',marginBottom:'2%' }}>
        <button onClick={dispatchPlan} style={{background:'#7ec5ea',color:'#fff'}}>
          <i className="fa fa-angle-double-right css-zfl09c" aria-hidden="true" />
          Dispatch
        </button>
      </div>
        {activeTab === 'allocated' && (
          <div>
            
            <div className="sub-tabs">
              <div className={`sub-tab ${activeSubTab === 'timeline' ? 'active' : ''}`}  onClick={() => handleSubTabClick('timeline')}>Timeline</div>
              <div className={`sub-tab ${activeSubTab === 'details' ? 'active' : ''}`} onClick={() => handleSubTabClick('details')}>Details</div>
            </div>

            <div className="sub-tab-content">
              {activeSubTab === 'details' && (
                <div className="row">
                  <div className="col-md-7">
                    <table style={{ borderCollapse: 'collapse', width: '100%' }} className="displatchtable">
                      <thead>
                        <tr>
                          <th><input className="check" type="checkbox" checked={selectAll}
                onChange={handleSelectAllChange} /> Plan</th>
                          <th>Driver</th>
                          <th>status</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {routes.map((route) => (
                          <tr key={route.route_id} 
                          onClick={() => handleRouteClick(route)} // Set the selected route on row click
                          style={{ cursor: 'pointer' }}>
                            <td><input className="check" type="checkbox"  checked={selectedRoutes[route.order_id] || false}
                  onChange={(e) => handleRouteChange(route.order_id, e)} /> {route.order_id}</td>
                            {/* <td>{route.driver_name}</td> */}
                            <td>
              {/* Driver Select Dropdown */}
              <select
                value={selectedDrivers[route.order_id] || ""}
                onChange={(e) => handleDriverChange(route.order_id, e.target.value)}
              >
                <option value="">Select Driver</option>
                {driversall.map(driver => (
                  <option key={driver.driverId} value={driver.driverId}>
                    {driver.name}
                  </option>
                ))}
              </select>
            </td>
                            <td>{dispatchedOrders.includes(route.order_id) ? "Dispatched" : "Planned"}</td>
                          
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-5">
                  {selectedRouteMap ? (
                    //use API key to display the below
        //   <iframe
        //     src={`https://www.google.com/maps/embed/v1/view?zoom=14&center=${selectedRouteMap.latitude},${selectedRouteMap.longitude}`}
        //     width="100%"
        //     height="300"
        //     style={{ border: 0 }}
        //     allowFullScreen
        //     loading="lazy"
        //   ></iframe>
          <iframe
          title="Route Map View"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3633.407929454389!2d55.30751231546286!3d25.276987183839694!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d4ec9b0515f%3A0x7c7b9432fa6a7d08!2sDubai%2C%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1615892540846!5m2!1sen!2sin"
          width="100%" height="300" style={{ border: 0 }} allowFullScreen loading="lazy">
        </iframe>
        ) : (
          <p>Select a route to see the map</p>
        )}</div>
                </div>
              )}

              {activeSubTab === 'timeline' && (
                <div className="row">
                  <div className="col-md-7">
                    <table style={{ borderCollapse: 'collapse', width: '100%' }} className="displatchtable">
                      <thead>
                        <tr>
                          <th>Plan</th>
                          <th>Timeline</th>
                        </tr>
                      </thead>
                      <tbody>
                        {routes.map((route) => (
                          <tr key={route.route_id}>
                            <td>{route.route_id}</td>
                            <td>
                              <div style={{ position: 'relative', height: '50px' }}>
                                <div style={{
                                  position: 'absolute', top: '20px', left: '0%', width: '100%', height: '5px', backgroundColor: '#ccc'
                                }}></div>
                                <div style={{
                                  position: 'absolute', top: '15px', left: '0%', width: '5px', height: '20px', backgroundColor: 'green'
                                }} title="8 AM"></div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-5">
                  <iframe
  title="Timeline Map View"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3633.407929454389!2d55.30751231546286!3d25.276987183839694!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d4ec9b0515f%3A0x7c7b9432fa6a7d08!2sDubai%2C%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1615892540846!5m2!1sen!2sin"
  width="100%" height="300" style={{ border: 0 }} allowFullScreen loading="lazy">
</iframe></div>
                </div>
              )}
            </div>
          </div>
        )}
       
        {activeTab === 'unallocated' && <div> <div className="row">
                  <div className="col-md-7">
                    <table style={{ borderCollapse: 'collapse', width: '100%' }} className="displatchtable">
                      <thead>
                        <tr>
                          <th> Plan</th>
                          <th>Driver</th>
                          <th>Vehicle</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {routesUnassigned.map((route) => (
                          <tr key={route.route_id} 
                          onClick={() => handleRouteClick(route)} // Set the selected route on row click
                          style={{ cursor: 'pointer' }}>
                            <td><input className="check" type="checkbox"  checked={selectedRoutes[route.order_id] || false}
                  onChange={(e) => handleRouteChange(route.order_id, e)} /> {route.order_id}</td>
                            {/* <td>{route.driver_name}</td> */}
                            <td>
              {/* Driver Select Dropdown */}
              <select
                value={selectedDrivers[route.order_id] || ""}
                onChange={(e) => handleDriverChange(route.order_id, e.target.value)}
              >
                <option value="">Select Driver</option>
                {driversall.map(driver => (
                  <option key={driver.driverId} value={driver.driverId}>
                    {driver.name}
                  </option>
                ))}
              </select>
            </td>
            <td>{dispatchedOrders.includes(route.order_id) ? "Dispatched" : "Planned"}</td>
                          
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div></div>
                  
                  </div>}
      </div>
    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}
